import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledContainer = styled.section`
  max-width: ${container('xl')};
  margin: auto;
  padding: ${spacing('xl')} ${spacing('md')} ${spacing('xl3')};
`;

export const StyledHeader = styled.div`
  max-width: ${container('md')};
  margin: auto;
  text-align: center;

  p {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;

export const StyledSteps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spacing('xl4')} auto;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: stretch;
  }
`;

export const StyledStepsItem = styled.div`
  max-width: 25rem;
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('lg')};
  padding-left: ${spacing('lg')};
  padding-right: ${spacing('lg')};
  position: relative;
  font-size: ${fontSize('sm')};
  line-height: 1.42;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (min-width: ${screen('lg')}) {
    width: 20%;
    padding-left: ${spacing('xl3')};
    padding-top: ${spacing('xl')};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -${spacing('xl')};
    left: 0;
    right: 0;
    height: ${spacing('xl')};
    clip-path: polygon(0 0, 100% 0, 50% 100%);
    z-index: 1;

    @media (min-width: ${screen('lg')}) {
      top: 0;
      bottom: 0;
      left: unset;
      right: -${spacing('xl')};
      height: unset;
      width: ${spacing('xl')};
      clip-path: polygon(0 0, 100% 50%, 0 100%);
    }
  }

  &:first-of-type {
    background-color: ${color('navy_100')};

    &::after {
      background-color: ${color('navy_100')};
    }
  }

  &:nth-of-type(2) {
    background-color: ${color('navy_200')};

    &::after {
      background-color: ${color('navy_200')};
    }
  }

  &:nth-of-type(3) {
    background-color: ${color('navy_300')};

    &::after {
      background-color: ${color('navy_300')};
    }
  }

  &:nth-of-type(4) {
    background-color: ${color('navy_500')};

    &::after {
      background-color: ${color('navy_500')};
    }
  }

  &:last-of-type {
    background-color: ${color('navy_600')};

    &::after {
      background-color: ${color('navy_600')};
    }
  }

  &:nth-of-type(n + 3) {
    color: ${color('white')};
  }
`;

export const StyledStepsTitle = styled.span`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl2')};
  line-height: 1;
  font-weight: ${fontWeight('semiBold')};
  text-transform: uppercase;

  @media (min-width: ${screen('lg')}) {
    min-height: 2em;
  }
`;

export const StyledActions = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${spacing('lg')};
`;
